import { withStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import * as v from '../../../helpers/validation';
import classnames from 'classnames';
// SERVICES
import { getCallCenterUserById, putCallCenterUser } from '../../../services/callcenter.service';
import { DynamicForm } from '../../DynamicForm';
import { Button } from '@material-ui/core';

const styles = props => ({});

export const CallCenterUsersDetail = withStyles(styles)(props => {
  console.log({props})
  const { match } = props;
  const { userId } = props.match.params;

  const [callCenterUserFormData, setCallCenterUserFormData] = useState(null);
  const [formError, setFormError] = useState('');
  const [initAccountStatusId, setInitAccountStatusId] = useState(false);
  const [currentAccountStatusId, setCurrentAccountStatusId] = useState(null);

  useEffect(() => {
    const getCallCenterUserAsync = async () => {
      try {
        let callCenterUserObj = await getCallCenterUserById(userId);
        callCenterUserObj.callCenterUserId = userId;
        const originalAccountStatusId = callCenterUserObj.accountStatusId;
        callCenterUserObj.accountStatusId = callCenterUserObj?.accountStatusId != null ? String(callCenterUserObj.accountStatusId) : callCenterUserObj?.accountStatusId;
        setCallCenterUserFormData(callCenterUserObj);
        setInitAccountStatusId(originalAccountStatusId);
        setCurrentAccountStatusId(originalAccountStatusId);
      } catch (err) {
        setFormError('Error loading call center user data');
        console.log(err);
      }
    };

    getCallCenterUserAsync();
  }, [userId]);

  const handleSave = async (formData) => {
    // Check if transitioning from inactive to active
    const isTransitioningToActive = initAccountStatusId !== 1 && currentAccountStatusId === 1;
    const isPasswordRequired = isTransitioningToActive;
    const hasPassword = formData.password && formData.password.trim().length > 0;

    if (isPasswordRequired && !hasPassword) {
      throw new Error('Password is required when activating an inactive user.');
    }

    // If password is provided, validate password strength
    if (hasPassword) {
      const passwordError = v.password()(formData.password);
      if (passwordError) {
        throw new Error(passwordError);
      }
    }

    return await putCallCenterUser(formData);
  };

  const customActionsPanel = ({ isSubmitting, onSave, submitError, submitSuccess }) => (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: 12 }}>
        {onSave && (
      <Button
        disabled={isSubmitting}
        variant="contained"
        style={{ backgroundColor: '#17c80d', color: '#fff', marginRight: 10 }}
        onClick={onSave}
      >
        {isSubmitting ? 'Saving…' : 'Save'}
      </Button>
      )}
      {!!submitError && <span style={{ marginLeft: 12, color: 'red' }}>{submitError}</span>}
      {!!submitSuccess && <span style={{ marginLeft: 12, color: 'green' }}>Success</span>}
    </div>
  );

  const callCenterUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'email',
              label: 'E-mail',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              disabled: true,
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'name',
              label: 'Name',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'workPhone',
              label: 'Work Phone',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'homePhone',
              label: 'Home Phone',
              validate: [],
            },
            {
              inputType: 'text',
              field: 'cellPhone',
              label: 'Cell Phone',
              validate: [],
            },
            {
              inputType: 'select',
              field: 'accountStatusId',
              label: 'Account Status',
              options: [
                { value: '1', label: 'Active' },
                { value: '2', label: 'Inactive' },
              ],
              validate: [v.checkAccountStatus('Record Type must be `Active` or `Inactive`')],
              onChange: (value) => setCurrentAccountStatusId(parseInt(value)),
            },
          ],
        },
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'address',
              label: 'Address',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'city',
              label: 'City',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'state',
              label: 'State',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'zip',
              label: 'Zip',
              validate: [v.required()],
            },
            {
              inputType: 'textarea',
              field: 'notes',
              label: 'Additional Notes',
            },
            ...(currentAccountStatusId === 1 ? [{
              inputType: 'text',
              field: 'password',
              label: 'Update Password',
              placeholder: initAccountStatusId !== 1 && currentAccountStatusId === 1
                ? 'Password required (min 6 chars, 1 uppercase, 1 digit, 1 special char)'
                : 'Enter a new password (min 6 chars, 1 uppercase, 1 digit, 1 special char)',
              validate: initAccountStatusId !== 1 && currentAccountStatusId === 1
                ? [v.required(), v.password()]
                : [v.password()],
            }] : []),
          ],
        },
      ],
    },
  ];

  return (
    <div className={classnames('grid-container')}>
      <DynamicForm
        inputs={callCenterUserInputs}
        data={callCenterUserFormData}
        mode={'EDIT'}
        onSave={handleSave}
        hideSubmitButton
        redirectOnSuccess={'/users/callcenter'}
        customActionsPanel={customActionsPanel}
      />
      <div>{formError}</div>
    </div>
  );
}); 